<template>
  <div>
    <multi-chart-box v-if="dataLoaded"
                     :data="chartData"
                     :chart-options="chartOptions"
                     :data-labels="dataLabels"
                     :bar-chart-data-select-options="barChartDataSelectOptions"
                     :line-chart-data-select-options="lineChartDataSelectOptions"
                     :interval="interval"
                     :loading="dataLoading"
                     @reload="reloadData"
    />
    <vue-element-loading v-else style="min-height: 500px; z-index: 1" :active="loading" :is-full-screen="false"/>
  </div>
</template>

<script>
import MultiChartBox from '@/components/Dashboard/MultiChartBox';
import Action from '@/services/Action/Action';
import Priority from '@/services/Action/Priority';
import { cloneDeep } from 'lodash';
import {FRA_DUE_DATES, WORKPLAN_DUE_DATES} from "@/store/mutation-types";

export default {
  name: 'ActionMultiChart',
  components: {
    MultiChartBox,
  },
  data() {
    return {
      interval: 'month',
      priorities: null,
      loading: false,
      dataLoading: false,
      dataLoaded: false,
      chartOptions: {
        barChart: {
          colors: ['#DE4618', '#34668C', '#99B3C5', '#FFA600', '#E87D5C', '#638BC2', '#96CBFA'],
          xaxis: {
            type: 'category',
            categories: [],
            labels: {
              style: {
                fontSize: '8px',
                cssClass: 'uppercase-axis',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '8px',
              },
            },
          },
        },
        lineChart: {
          colors: ['#DE4618', '#34668C', '#99B3C5', '#FFA600', '#E87D5C', '#638BC2', '#96CBFA'],
          xaxis: {
            type: 'category',
            categories: [],
            labels: {
              style: {
                fontSize: '8px',
                cssClass: 'uppercase-axis',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '8px',
              },
            },
          },
          markers: {
            size: 4,
            colors: ['#FFFFFF'],
            strokeColors: ['#DE4618', '#34668C', '#99B3C5', '#FFA600', '#E87D5C', '#638BC2', '#96CBFA'],
          },
        },
        table: {
          columnDefs: [],
          gridOptions: {},
          gridApi: null,
          columnApi: null,
          rowHeight: 47.5,
          rowData: [],
        },
      },
      levelOptions: [
        {
          label: 'TOTAL',
          value: 0,
          formValue: 0,
        },
        {
          label: 'LEVEL 1',
          value: 0,
          formValue: 1,
        },
        {
          label: 'LEVEL 2',
          value: 0,
          formValue: 2,
        },
        {
          label: 'LEVEL 3',
          value: 0,
          formValue: 3,
        },
      ],

      priorityApiResponse: null,
    }
  },
  computed: {
    dataLabels() {
      if (!this.priorities) {
        return [];
      }

      return this.priorities.map(item => {
        return {
          id: item.priorityId,
          name: item.priority,
        }
      });
    },
    priorityOptions() {
      if (!this.priorities) {
        return [];
      }

      return this.priorities.map(item => {
        return {
          formName: 'priority-select',
          formValue: item.priorityId,
          label: item.priority,
          value: 0,
          checked: true,
        }
      });
    },
    barChartDataSelectOptions() {
      if (!this.levelOptions) {
        return [];
      }

      return this.levelOptions.map(item => {
        return {
          formName: 'bar-chart-data-select',
          formValue: item.formValue,
          label: item.label,
          value: item.value,
        }
      });
    },
    lineChartDataSelectOptions() {
      if (!this.levelOptions) {
        return [];
      }

      return this.levelOptions.map(item => {
        return {
          formName: 'line-chart-data-select',
          formValue: item.formValue,
          label: item.label,
          value: item.value,
        }
      });
    },

    chartData () {
      if (!this.priorityApiResponse) {
        return [];
      }
      if (this.$store.getters.dueDateBy === WORKPLAN_DUE_DATES && this.priorityApiResponse[WORKPLAN_DUE_DATES].length > 0) {
        return this.priorityApiResponse[WORKPLAN_DUE_DATES];
      }
      return this.priorityApiResponse[FRA_DUE_DATES];
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.dataLoading = true;

      try {
        await Promise.all([this.getPriorities(), this.getChartData()]);
        this.dataLoaded = true;
      } catch (e) {
        this.$notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          type: 'error',
        });
      } finally {
        this.loading = false;
        this.dataLoading = false;
      }
    },
    async getPriorities() {
      const { data } = await Priority.list();
      this.priorities = data.data;
    },
    async getChartData() {
      const { data } = await Action.getPriorityCounts(this.$store.getters.complianceTypeId, this.interval, this.$store.getters.propertyTenure);
      this.priorityApiResponse = data.data;
    },
    async reloadData(interval) {
      this.dataLoading = true;
      try {
        this.interval = interval;
        await this.getChartData();
      } catch (e) {
        this.$notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          type: 'error',
        });
      } finally {
        this.dataLoading = false;
      }

    },
    onLegendClick() {
      console.log("legeng clicked");
    }
  }
};
</script>

<style scoped>

</style>
